/** 错误日志 */
import './index.scss';
import React from 'react';
import { Table, Card, Button, Tooltip, Select, message,Input } from 'antd';
import DateTimePicker from "../../components/DateTimePicker";
import api from '../../lib/api';
import IconFont from '../../components/IconFont/index';
const { Option } = Select;
let isChangeSize = false; // 标识位 判断是否切换分页条数

class errorDetail extends React.Component {
  state = {
    dateTimeVal: '3天',
    option: {
      startTime: null,
      endTime: null
    },
    showFilterPopup: false,
    filterData: {
      url: '',
      errorType:'',
      methodType:'',
      httpCode:'',
      resourceType:'',
      browserVersion:'',
      systemType:'',
      deviceType:''
    },
    filterDataClone: {},
    scrollY: 600,
    loadingtable: false,
    total: 2,
    current: 1,
    tableData: [],
    columns: [{
      title: '报错时间',
      dataIndex: 'errorTime',
      width: 140
    }, {
      title: 'url',
      dataIndex: 'url'
    }, {
      title: '报错类型',
      dataIndex: 'errorType',
      width: 80
    }, {
      title: '请求类型',
      dataIndex: 'methodType',
      width: 70
    }, {
      title: '状态码',
      dataIndex: 'httpCode',
      width: 60
    }, {
      title: '资源类型',
      dataIndex: 'resourceType',
      width: 70
    }, {
      title: '请求资源路径',
      dataIndex: 'resourceUrl'
    }, {
      title: '错误信息',
      dataIndex: 'responseData',
      ellipsis: {
        showTitle: false,
      },
      render: responseData => (
        <Tooltip overlayStyle={{ maxWidth: '500px' }} placement="topLeft" title={responseData}>
          {responseData}
        </Tooltip>
      ),
    }, {
      title: 'js错误行',
      dataIndex: 'errorRow',
      width: 80
    }, {
      title: 'js错误列',
      dataIndex: 'errorLine',
      width: 80
    }, {
      title: '浏览器版本',
      dataIndex: 'browserVersion',
      width: 150
    }, {
      title: '系统',
      dataIndex: 'systemType',
      width: 70
    }, {
      title: '设备',
      dataIndex: 'deviceType',
      width: 90
    }, {
      title: 'IP',
      dataIndex: 'ip',
      width: 120
    }]
  };
  // 日期选择
  handleDateTimePicker = (dateTimeVal, startTime, endTime) => {
    const option = Object.assign({}, this.state.option, { startTime, endTime });
    this.setState({
      dateTimeVal,
      option
    }, () => {
      this.getTabledata({ size: this.state.pageSize })
    })
  };

  // 导出
  exportFile = () => {
    const { option,filterData } = this.state;
    api.exportErrorLog({ startTime: option.startTime, endTime: option.endTime, ...filterData, projectId: sessionStorage.getItem('projectId') }).then(res => {
      this.uploadData(res);
    })
  };
  uploadData = (res) => {
    if (res.type === 'application/json') {
      message.error("当前没有数据可下载");
      return;
    }
    let xx = "content-disposition";
    let url = window.URL.createObjectURL(new Blob([res["data"]]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    let filename = decodeURIComponent(res.headers[xx].split(";")[1].split("=")[1].split('"')[1]);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
  };
  getTabledata({ page = 1, size = 30 }) {
    this.setState({ loadingtable: true })
    api.errorLogList({ ...this.state.option,...this.state.filterData, page, pageSize: size }).then(res => {
      this.setState({ loadingtable: false })
      if (res.status === 200 && res.success) {
        this.setState({
          tableData: res.data || [],
          total: res.total,
          current: page
        })
      } else {
        message.error(res.message);
      }
    })
  };
  handleTableChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "paginate") {
      if (isChangeSize) {
        isChangeSize = false;
        this.getTabledata({ page: 1, size: pagination.pageSize })
      } else {
        this.getTabledata({ page: pagination.current, size: pagination.pageSize })
      }
    }
  };

  // 条数点击 页数/条数
  onShowSizeChange = (current, size) => {
    isChangeSize = true;
  };
  errorChange = (val) => {
    const option = Object.assign(this.state.option, { errorType: val })
    this.setState({
      option
    }, () => {
      this.getTabledata({ size: this.state.pageSize })
    })
  };
  /** 显示/隐藏筛选弹窗 */
  handleShowFilter(bol) {
    bol ? this.setState({
      filterDataClone: JSON.parse(JSON.stringify(this.state.filterData))
    }) : this.setState({
      filterData: JSON.parse(JSON.stringify(this.state.filterDataClone))
    })
    this.setState({
      showFilterPopup: bol
    })
  };
  /** 更改筛选数据 */
  handleFilterChange(key, val,isSelect) {
    let obj = this.state.filterData;
    obj[key] = isSelect ? val : val.target.value;
    this.setState({filterData:obj});
  };
  /** 确定筛选 */
  handleConfirmFilter(){
    this.getTabledata({ size: this.state.pageSize })
    this.setState({
      showFilterPopup: false
    })
  };
  UNSAFE_componentWillMount() {
    this.setState({
      scrollY: document.documentElement.clientHeight - 350
    });
    window.onresize = () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 350
      })
    }
  }
  render() {
    const { dateTimeVal, loadingtable, total, current, columns, tableData, scrollY,showFilterPopup,filterData } = this.state;
    return (
      <Card>
        <div className="search-module mBot15">
          <div className="clear">
            <IconFont type="icon-shaixuantiaojian" style={{ fontSize: 26 }} className="filter-icon" onClick={() => this.handleShowFilter(true)} />
            <DateTimePicker comClassName='float-r' value={dateTimeVal} handleDateTimePicker={this.handleDateTimePicker} />
          </div>
          <Button type="primary" onClick={this.exportFile}>导出</Button>
        </div>
        <Table
          scroll={{ x: 1600, y: scrollY }}
          className="mTop10"
          rowKey={(record, index) => index}
          bordered={true}
          loading={loadingtable}
          dataSource={tableData}
          columns={columns}
          pagination={{
            defaultPageSize: 30,
            showTotal: (total) => `共${total}条数据`,
            total: Number(total),
            current: Number(current),
            pageSizeOptions: ["30", "50", "100"],
            showSizeChanger: true,
            showQuickJumper: true,
            onShowSizeChange: this.onShowSizeChange
          }}
          onChange={this.handleTableChange}
        />
        {/** 筛选弹窗 */}
        {showFilterPopup ? <div className="filter-popup">
          <div className="popup-shadow"></div>
          <div className="filter-module">
            <div className="filter-input">
              <div>
                <p>URL</p>
                <Input allowClear={true} value={filterData.url} onChange={val => this.handleFilterChange('url', val)} />
              </div>
              <div>
                <p>报错类型</p>
                <Select value={filterData.errorType} allowClear={true} className="url-select" placeholder="请选择" onChange={val => this.handleFilterChange('errorType', val,'isSelect')}>
                  <Option value="http">http报错</Option>
                  <Option value="js">js报错</Option>
                </Select>
              </div>
              <div>
                <p>请求类型</p>
                <Select value={filterData.methodType} allowClear={true} className="url-select" placeholder="请选择" onChange={val => this.handleFilterChange('methodType', val,'isSelect')}>
                  <Option value="GET">GET</Option>
                  <Option value="POST">POST</Option>
                </Select>
              </div>
              <div>
                <p>状态码</p>
                <Input allowClear={true} value={filterData.httpCode} onChange={val => this.handleFilterChange('httpCode', val)} />
              </div>
              <div>
                <p>资源类型</p>
                <Select allowClear={true} value={filterData.resourceType} className="url-select" placeholder="请选择" onChange={val => this.handleFilterChange('resourceType', val,'isSelect')}>
                  <Option value="xmlhttprequest">xmlhttprequest</Option>
                  <Option value="fetch">fetch</Option>
                  <Option value="script">script</Option>
                  <Option value="img">img</Option>
                  <Option value="css">css</Option>
                  <Option value="iframe">iframe</Option>
                  <Option value="other">other</Option>
                </Select>
              </div>
              <div>
                <p>错误信息</p>
                <Input allowClear={true} value={filterData.responseData} onChange={val => this.handleFilterChange('responseData', val)} />
              </div>
              <div>
                <p>浏览器版本</p>
                <Input allowClear={true} value={filterData.browserVersion} onChange={val => this.handleFilterChange('browserVersion', val)} />
              </div>
              <div>
                <p>系统</p>
                <Input allowClear={true} value={filterData.systemType} onChange={val => this.handleFilterChange('systemType', val)} />
              </div>
              <div>
                <p>设备</p>
                <Input allowClear={true} value={filterData.deviceType} onChange={val => this.handleFilterChange('deviceType', val)} />
              </div>
            </div>
            <p>
              <Button type="primary" onClick={() => this.handleConfirmFilter()} >确定</Button>
              <Button onClick={() => this.handleShowFilter(false)} >取消</Button>
            </p>
          </div>
        </div> : ''}
      </Card>
    );
  }
};
export default errorDetail;
